"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = exports.TreePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Checkbox_1 = require("../_forms/Checkbox");
var Icon_1 = require("../Icon");
var IconSymbols_1 = require("../../generated/IconSymbols");
var enums_1 = require("../../enums");
var Pill_1 = require("../Pill");
var areNoneSelected = function (data) {
    for (var i = 0; i < data.length; i++) {
        if (data[i].isChecked === true)
            return false;
    }
    return true;
};
var TreePicker = function (_a) {
    var data = _a.data, searchTerm = _a.searchTerm, onItemSelected = _a.onItemSelected, showSelectAll = _a.showSelectAll, isCascading = _a.isCascading;
    var isCompletelyUnchecked = areNoneSelected(data);
    var _b = (0, react_1.useState)(isCompletelyUnchecked), isSelectAll = _b[0], setIsSelectAll = _b[1];
    var _c = (0, react_1.useState)(data), treeData = _c[0], setTreeData = _c[1];
    var _d = (0, react_1.useState)(!isCompletelyUnchecked), isIndeterminate = _d[0], setIsIndeterminate = _d[1];
    var _e = (0, react_1.useState)(!isCompletelyUnchecked), isChecked = _e[0], setIsChecked = _e[1];
    var dataCount = data.length;
    (0, react_1.useEffect)(function () {
        if (!searchTerm)
            setTreeData(data);
        if (searchTerm) {
            var searchedData = data.map(function (e) {
                var lowerSearchTerm = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase();
                e.isActive = lowerSearchTerm.length > 2 && e.label.toLowerCase().includes(lowerSearchTerm) ? true : false;
                return e;
            });
            setTreeData(searchedData);
        }
    }, [data, searchTerm]);
    var shouldBeIndeterminate = function (checkedData) {
        var someChecked = checkedData.length < dataCount && checkedData.length > 0;
        if (searchTerm.length > 0 && isSelectAll) {
            setIsIndeterminate(true);
            return;
        }
        setIsIndeterminate(someChecked);
    };
    var toggleSelect = function () {
        var newTreeData = treeData.map(function (e) {
            e.isChecked = isSelectAll;
            return e;
        });
        var checkedData = isSelectAll ? newTreeData : [];
        onItemSelected(checkedData, newTreeData);
        setTreeData(newTreeData);
        setIsSelectAll(!isSelectAll);
        setIsChecked(checkedData.length > 0);
        shouldBeIndeterminate(checkedData);
    };
    var cascadeToChild = function (itemId, isChecked) {
        data.filter(function (e) { return e.parent === itemId; }).map(function (e) { return e.isChecked = isChecked; });
        var children = data.filter(function (e) { return e.parent === itemId; });
        children.forEach(function (c) {
            if (!c.hasChildren)
                return;
            cascadeToChild(c.id, isChecked);
        });
        return data;
    };
    var cascadeToParent = function (parentId) {
        var parent = data.filter(function (e) { return e.id === parentId; }).map(function (e) {
            e.isChecked = true;
            return e;
        })[0];
        if (parent.parent) {
            data = cascadeToParent(parent.parent);
        }
        return data;
    };
    var updateSelected = function (itemId, isChecked) {
        var data = treeData;
        isCascading ?
            data.forEach(function (e) {
                if (e.id !== itemId && e.parent !== itemId)
                    return e;
                e.isChecked = isChecked;
                if (e.parent && isChecked) {
                    data = cascadeToParent(e.parent);
                }
                if (!e.hasChildren)
                    return e;
                data = cascadeToChild(e.id, isChecked);
                if (!e.isChecked)
                    setIsSelectAll(true);
            })
            :
                data.filter(function (e) { return e.id === itemId; }).map(function (e) { return e.isChecked = isChecked; });
        var checkedData = data.filter(function (e) { return e.isChecked === true; });
        setIsChecked(checkedData.length > 0);
        setIsSelectAll(checkedData.length !== data.length);
        onItemSelected(checkedData, data);
        shouldBeIndeterminate(checkedData);
        setTreeData(__spreadArray([], data, true));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [showSelectAll &&
                (0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-flex align-items-center mb-2" }, { children: [(0, jsx_runtime_1.jsx)(Checkbox_1.ReactCheckbox, { onClick: toggleSelect, checked: isChecked, indeterminate: isIndeterminate, className: "d-inline-block pr-2 ".concat(isChecked ? 'tree-checkbox__checked' : 'tree-checkbox__unchecked') }), (0, jsx_runtime_1.jsx)("span", { children: isSelectAll ? 'Select All' : 'Clear All' })] })), (0, jsx_runtime_1.jsx)(exports.Tree, { data: treeData, onItemSelected: onItemSelected, updateSelected: updateSelected })] }));
};
exports.TreePicker = TreePicker;
var Tree = function (_a) {
    var data = _a.data, _b = _a.parent, parent = _b === void 0 ? 0 : _b, _c = _a.level, level = _c === void 0 ? 0 : _c, onItemSelected = _a.onItemSelected, updateSelected = _a.updateSelected;
    var items = data
        .filter(function (item) { return item.parent === parent; })
        .sort(function (a, b) { return (a.label > b.label ? 1 : -1); });
    if (!items.length)
        return null;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: items.map(function (item) {
            return (0, jsx_runtime_1.jsx)(Row, __assign({ item: item, level: level, updateSelected: updateSelected }, { children: (0, jsx_runtime_1.jsx)(exports.Tree, { data: data, parent: item.id, level: level + 1, onItemSelected: onItemSelected, updateSelected: updateSelected }) }), item.id + "".concat(item.isChecked));
        }) }));
};
exports.Tree = Tree;
var Row = function (_a) {
    var item = _a.item, level = _a.level, children = _a.children, updateSelected = _a.updateSelected;
    var _b = (0, react_1.useState)(item.isCollapsed), isCollapsed = _b[0], setIsCollapsed = _b[1];
    var _c = (0, react_1.useState)(item.isChecked), isChecked = _c[0], setIsChecked = _c[1];
    var onCheckboxClick = function (e, item) {
        setIsChecked(!isChecked);
        updateSelected(item.id, !isChecked);
    };
    var toggleCollapse = function () {
        setIsCollapsed(!isCollapsed);
        item.isCollapsed = !isCollapsed;
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "check-tree__indent-".concat(level + 2, " my-1  ") }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-flex align-items-center" }, { children: [!item.hasChildren ? (0, jsx_runtime_1.jsx)("div", { className: "pl-3" }) : ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: isCollapsed ? IconSymbols_1.IconSymbols.ChevronRight : IconSymbols_1.IconSymbols.ChevronDown, size: enums_1.UiSizes.SM, onClick: toggleCollapse })), (0, jsx_runtime_1.jsx)(Checkbox_1.ReactCheckbox, { onClick: function (e) { return onCheckboxClick(e, item); }, checked: isChecked, className: "d-inline-block pr-2 ".concat(isChecked ? 'tree-checkbox__checked' : 'tree-checkbox__unchecked') }), item.isActive ? (0, jsx_runtime_1.jsx)(Pill_1.Pill, { children: item.label }) : (0, jsx_runtime_1.jsx)("span", { children: item.label })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: isCollapsed ? "check-tree__hidden" : "" }, { children: children }))] }), item.id));
};
